import CancelCreateRequest from "@pagesChannel/ChannelManagement/CancelChannel/CreateRequest";
import { lazy as lazyReact } from "react";
import PrivateRoute from "./PrivateRouter";
import {
  // ACTION,
  ACTION_ALLOW,
  ROLE,
  UAA_CHILDREN_PATH,
} from "./constant";
import {
  roleActionDetailChannel,
  roleCancelCreateRequest,
  roleCashinApprove,
  roleCashinRequest,
  roleFundingRequest,
  roleFundingReview,
  rolePaymentReview,
  roleSysUser,
  roleTransactionHistory,
  roleWithdraw_Approve,
  roleWithdraw_Create,
  roleWithdraw_Review,
} from "./routeRole";

// try to fix chunk error
const lazy = (componentImport) =>
  lazyReact(async () => {
    try {
      const component = await componentImport();
      return component;
    } catch (error) {
      return window.location.reload();
    }
  });
//CHANNEL
const RegisterCreateRequest = lazy(() =>
  import("@pagesChannel/ChannelManagement/RegisterChannel/CreateRequest")
);
const UpdateApproveRequest = lazy(() =>
  import("@pagesChannel/ChannelManagement/UpdateChannel/ApproveRequest")
);
const UpdateCreateRequest = lazy(() =>
  import("@pagesChannel/ChannelManagement/UpdateChannel/CreateRequest")
);
const EditCreateRequest = lazy(() =>
  import("@pagesChannel/ChannelManagement/RegisterChannel/EditRequest")
);

const CancelApproveRequest = lazy(() =>
  import("@pagesChannel/ChannelManagement/CancelChannel/ApproveRequest/List")
);

const DetailChannel = lazy(() =>
  import("@pagesChannel/ChannelManagement/DetailChannel")
);
const DetailCancelChannel = lazy(() =>
  import(
    "@pagesChannel/ChannelManagement/CancelChannel/ApproveRequest/DetailChannel"
  )
);

const Overview = lazy(() => import("@pagesChannel/ChannelManagement/Overview"));

const ManageSysUserList = lazy(() =>
  import("@pagesChannel/ChannelManagement/ManageSysUser/List")
);

const ManageSysUserCreate = lazy(() =>
  import("@pagesChannel/ChannelManagement/ManageSysUser/Create")
);

//WITHDRAW
const WithdrawCreateAdd = lazy(() =>
  import("@pagesChannel/FundingManagement/Withdraw/Create/Add")
);
const WithdrawCreateDetail = lazy(() =>
  import("@pagesChannel/FundingManagement/Withdraw/Detail")
);
const WithdrawCreate = lazy(() =>
  import("@pagesChannel/FundingManagement/Withdraw/Create")
);
const WithdrawRequest = lazy(() =>
  import("@pagesChannel/FundingManagement/Withdraw/Review")
);

const WithdrawApprove = lazy(() =>
  import("@pagesChannel/FundingManagement/Withdraw/Approve")
);

// cashIn
const CashInRequest = lazy(() =>
  import("@pagesChannel/FundingManagement/CashIn/Request")
);
const CashInApprove = lazy(() =>
  import("@pagesChannel/FundingManagement/CashIn/Approve")
);
const CashInRequestAdd = lazy(() =>
  import("@pagesChannel/FundingManagement/CashIn/Add")
);
const CashInRequestDetail = lazy(() =>
  import("@pagesChannel/FundingManagement/CashIn/Detail")
);

//================ END ----FUNDING

const Dashboard = lazy(() => import("@pagesChannel/Ultilities/Dashboard"));

const TransactionHistory = lazy(() =>
  import("@pagesChannel/Ultilities/TransactionHistory")
);

//========= Report ==========
const ReportTotalTrans = lazy(() =>
  import("@pagesChannel/Report/ReportTotalByAccount")
);
const ReportEwalletCommissionByDate = lazy(() =>
  import("@pagesChannel/Report/ReportCommission/ReportEwalletCommissionByDate")
);
const ReportChannel = lazy(() => import("@pagesChannel/Report/ReportChannel"));
const ReportPaymentEwalletCommission = lazy(() =>
  import("@pagesChannel/Report/ReportCommission/ReportPaymentEwalletCommission")
);
const ReportEwalletCommissionByObject = lazy(() =>
  import(
    "@pagesChannel/Report/ReportCommission/ReportEwalletCommissionByObject"
  )
);
const ReportPercentage = lazy(() =>
  import("@pagesChannel/Report/ReportPercentage")
);
// const ReportAgentCommissionList = lazy(() =>
//   import("@pagesChannel/Report/ReportAgentCommission/ReportAgentCommissionList")
// );
const ReportChannelDetail = lazy(() =>
  import("@pagesChannel/Report/ReportChannelDetal")
);
const ReportCommissionList = lazy(() =>
  import("@pagesChannel/Report/ReportAgentCommission/ReportCommissionList")
);
const ReportCommissionDetail = lazy(() =>
  import("@pagesChannel/Report/ReportAgentCommission/ReportCommissionDetail")
);
const CommissionSatffReport = lazy(() =>
  import("@pagesChannel/Report/ReportCommission/CommissionStaffReport")
);
const ReportTransDetailByDate = lazy(() =>
  import("@pagesChannel/Report/ReportCommission/ReportTransDetailByDate")
);
// const ReportCommissionRoot = lazy(() =>
//   import("@pagesChannel/Report/ReportCommission/ReportCommissionRoot/List")
// );
// FUNDING
const FundingRequest = lazy(() =>
  import("@pagesChannel/FundingManagement/Emoney/Request")
);
const FundingDetail = lazy(() =>
  import("@pagesChannel/FundingManagement/Emoney/Detail")
);
const FundingRequestAdd = lazy(() =>
  import("@pagesChannel/FundingManagement/Emoney/Request/Add")
);
const FundingApprove = lazy(() =>
  import("@pagesChannel/FundingManagement/Emoney/Approve")
);
const FundingReview = lazy(() =>
  import("@pagesChannel/FundingManagement/Emoney/Review")
);

// Payment
const BatchRequest = lazy(() =>
  import("@pagesChannel/PaymentManagement/Request")
);

const BatchRequestAdd = lazy(() =>
  import("@pagesChannel/PaymentManagement/Request/Add")
);

const BatchRequestApprove = lazy(() =>
  import("@pagesChannel/PaymentManagement/Approve")
);

const BatchRequestDetail = lazy(() =>
  import("@pagesChannel/PaymentManagement/Detail")
);

const BatchRequestApproveDetail = lazy(() =>
  import("@pagesChannel/PaymentManagement/ApproveDetail")
);

const {
  ADMIN,
  HO_STAFF,
  HO_BO,
  HO_REVIEWER,
  SA_EXTERNAL_STAFF,
  SA_EXTERNAL_BO,
  SA_EXTERNAL_REVIEWER,
  AGENT_KEY_EXTERNAL,
  MD_EXTERNAL_STAFF,
  MD_EXTERNAL_REVIEWER,
  MD_EXTERNAL_BO,
  AGENT_EXTERNAL,
  AGENT_IN_SHOP_EXTERNAL,
} = ROLE;

const routeRootChannel = [
  {
    path: UAA_CHILDREN_PATH.ULTILITIES_DASHBOARD,
    element: (
      <PrivateRoute
        children={<Dashboard />}
        roles={{
          // [ADMIN]: {},
          [HO_BO]: {},
          [HO_STAFF]: {},
          [HO_REVIEWER]: {},
          [MD_EXTERNAL_BO]: {},
          [MD_EXTERNAL_REVIEWER]: {},
          [MD_EXTERNAL_STAFF]: {},
          [SA_EXTERNAL_BO]: {},
          [SA_EXTERNAL_STAFF]: {},
          [SA_EXTERNAL_REVIEWER]: {},
          [AGENT_KEY_EXTERNAL]: {},
          [AGENT_EXTERNAL]: {},
          [AGENT_IN_SHOP_EXTERNAL]: {},
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.OVERVIEW,
    element: (
      <PrivateRoute
        children={<Overview />}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: {},
          [HO_STAFF]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_STAFF]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_BO]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_REVIEWER]: {},
          [MD_EXTERNAL_BO]: {},
          [MD_EXTERNAL_REVIEWER]: {},
          [MD_EXTERNAL_STAFF]: {},
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REGISTER_CREATE_REQUEST,
    element: (
      <PrivateRoute
        children={<RegisterCreateRequest />}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: { ...ACTION_ALLOW },
          [HO_STAFF]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_STAFF]: { ...ACTION_ALLOW },
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REGISTER_APPROVE_REQUEST,
    element: (
      <PrivateRoute
        children={<UpdateApproveRequest key="Register_screen" isRegister />}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: { ...ACTION_ALLOW },
          // [SA_EXTERNAL_BO]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_REVIEWER]: { ...ACTION_ALLOW },
          [HO_STAFF]: { ...ACTION_ALLOW },
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REGISTER_APPROVE_REQUEST_APPROVE,
    element: (
      <PrivateRoute
        children={
          <DetailChannel
            key={UAA_CHILDREN_PATH.REGISTER_APPROVE_REQUEST_APPROVE}
            isApprove
            isRegister
          />
        }
        // roles={roleSearch_Detail_Approve_Register}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: { ...ACTION_ALLOW },
          // [SA_EXTERNAL_BO]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_REVIEWER]: { ...ACTION_ALLOW },
          [HO_STAFF]: { ...ACTION_ALLOW },
        }}
      />
    ),
  },
  //update channel ==============
  {
    path: UAA_CHILDREN_PATH.UPDATE_APPROVE_REQUEST,
    element: (
      <PrivateRoute
        children={<UpdateApproveRequest key="Update_screen" />}
        // roles={roleSearch_Detail_Approve_Update}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_STAFF]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_BO]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_REVIEWER]: { ...ACTION_ALLOW },
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.UPDATE_APPROVE_APPROVE,
    element: (
      <PrivateRoute
        children={<DetailChannel isApprove />}
        // roles={roleSearch_Detail_Approve_Update}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_STAFF]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_BO]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_REVIEWER]: { ...ACTION_ALLOW },
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.DETAIL_CHANNEL_UPDATE,
    element: (
      <PrivateRoute
        children={<UpdateCreateRequest />}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_STAFF]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_BO]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_REVIEWER]: { ...ACTION_ALLOW },
          [HO_STAFF]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: { ...ACTION_ALLOW },
          [MD_EXTERNAL_BO]: { ...ACTION_ALLOW },
          [MD_EXTERNAL_REVIEWER]: { ...ACTION_ALLOW },
          [MD_EXTERNAL_STAFF]: { ...ACTION_ALLOW },
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.DETAIL_CHANNEL_EDIT,
    element: (
      <PrivateRoute
        children={<EditCreateRequest />}
        roles={{
          [ADMIN]: {},
          [SA_EXTERNAL_STAFF]: {},
          [SA_EXTERNAL_BO]: {},
          [SA_EXTERNAL_REVIEWER]: {},
          [HO_STAFF]: {},
          [HO_BO]: {},
          [HO_REVIEWER]: {},
          [MD_EXTERNAL_BO]: {},
          [MD_EXTERNAL_REVIEWER]: {},
          [MD_EXTERNAL_STAFF]: {},
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CANCEL_APPROVE_REQUEST,
    element: (
      <PrivateRoute
        children={<CancelApproveRequest />}
        // roles={roleSearch_Detail_Approve_Register}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_BO]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_REVIEWER]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: { ...ACTION_ALLOW },
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CANCEL_APPROVE_APPROVE,
    element: (
      <PrivateRoute
        children={<DetailCancelChannel isApprove />}
        // roles={roleSearch_Detail_Approve_Register}
        roles={{
          [ADMIN]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_STAFF]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_REVIEWER]: { ...ACTION_ALLOW },
          [HO_BO]: { ...ACTION_ALLOW },
          [HO_STAFF]: { ...ACTION_ALLOW },
          [HO_REVIEWER]: { ...ACTION_ALLOW },
          [SA_EXTERNAL_BO]: { ...ACTION_ALLOW },
        }}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CANCEL_CREATE_REQUEST,
    element: (
      <PrivateRoute
        children={<CancelCreateRequest />}
        roles={roleCancelCreateRequest}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.DETAIL_CHANNEL,
    element: (
      <PrivateRoute
        children={<DetailChannel />}
        roles={roleActionDetailChannel}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REGISTER_CANCEL_REQUEST_DETAIL,
    element: (
      <PrivateRoute
        children={<DetailChannel isCancelRegister />}
        roles={roleCancelCreateRequest}
      />
    ),
  },
  // ============== Funding ==============
  {
    path: UAA_CHILDREN_PATH.WITHDRAW_CREATE,
    element: (
      <PrivateRoute children={<WithdrawCreate />} roles={roleWithdraw_Create} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.WITHDRAW_CREATE_ADD,
    element: (
      <PrivateRoute
        children={<WithdrawCreateAdd />}
        roles={roleWithdraw_Create}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.WITHDRAW_CREATE_EDIT,
    element: (
      <PrivateRoute
        children={<WithdrawCreateAdd isEdit />}
        roles={roleWithdraw_Create}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.WITHDRAW_CREATE_DETAIL,
    element: (
      <PrivateRoute
        children={<WithdrawCreateDetail isCancel />}
        roles={roleWithdraw_Create}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.WITHDRAW_REQUEST_DETAIL,
    element: (
      <PrivateRoute
        children={<WithdrawCreateDetail isReview />}
        roles={roleWithdraw_Review}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.WITHDRAW_REQUEST,
    element: (
      <PrivateRoute
        children={<WithdrawRequest />}
        roles={roleWithdraw_Review}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.WITHDRAW_APPROVE_DETAIL,
    element: (
      <PrivateRoute
        children={<WithdrawCreateDetail isApprove />}
        roles={roleWithdraw_Create}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.WITHDRAW_APPROVE,
    element: (
      <PrivateRoute
        children={<WithdrawApprove />}
        roles={roleWithdraw_Approve}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CASH_IN_REQUEST,
    element: (
      <PrivateRoute children={<CashInRequest />} roles={roleCashinRequest} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CASH_IN_APPROVE,
    element: (
      <PrivateRoute children={<CashInApprove />} roles={roleCashinApprove} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CASH_IN_CREATE_ADD,
    element: (
      <PrivateRoute children={<CashInRequestAdd />} roles={roleCashinRequest} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CASH_IN_REQUEST_EDIT,
    element: (
      <PrivateRoute
        children={<CashInRequestAdd isEdit />}
        roles={roleCashinRequest}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CASH_IN_REQUEST_DETAIL,
    element: (
      <PrivateRoute
        children={<CashInRequestDetail />}
        roles={roleCashinRequest}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.CASH_IN_APPROVE_DETAIL,
    element: (
      <PrivateRoute
        children={<CashInRequestDetail isApprove />}
        roles={roleCashinApprove}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.FUNDING_REQUEST,
    element: (
      <PrivateRoute
        children={<FundingRequest />}
        // roles={roleFundingCreate}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.FUNDING_REQUEST_ADD,
    element: (
      <PrivateRoute
        children={<FundingRequestAdd />}
        // roles={roleFundingCreate}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.FUNDING_REQUEST_EDIT,
    element: (
      <PrivateRoute
        children={<FundingRequestAdd isEdit />}
        // roles={roleFundingCreate}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.FUNDING_REQUEST_DETAIL,
    element: (
      <PrivateRoute
        children={<FundingDetail isCancel />}
        roles={roleFundingRequest}
      />
    ),
    // element: <FundingDetail />,
  },
  {
    path: UAA_CHILDREN_PATH.FUNDING_APPROVE,
    element: (
      <PrivateRoute
        children={<FundingApprove />}
        // roles={roleFundingApprove}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.FUNDING_APPROVE_DETAIL,
    element: (
      <PrivateRoute
        children={<FundingDetail isApprove />}
        // roles={roleFundingApprove}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.FUNDING_REVIEW,
    element: (
      <PrivateRoute children={<FundingReview />} roles={roleFundingReview} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.FUNDING_REVIEW_DETAIL,
    element: (
      <PrivateRoute
        children={<FundingDetail isReview />}
        roles={roleFundingReview}
      />
    ),
  },
  // Manage sys user =========
  {
    path: UAA_CHILDREN_PATH.MANAGE_SYS_USER_LIST,
    element: (
      <PrivateRoute children={<ManageSysUserList />} roles={roleSysUser} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.MANAGE_SYS_USER_CREATE,
    element: (
      <PrivateRoute children={<ManageSysUserCreate />} roles={roleSysUser} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.MANAGE_SYS_USER_DETAIL,
    element: (
      <PrivateRoute
        children={<ManageSysUserCreate isDetail />}
        roles={roleSysUser}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.MANAGE_SYS_USER_UPDATE,
    element: (
      <PrivateRoute
        children={<ManageSysUserCreate isEdit />}
        roles={roleSysUser}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.ULTILITIES_TRANSACTION,
    element: (
      <PrivateRoute
        children={<TransactionHistory />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REPORT_TOTAL_TRANS,
    element: (
      <PrivateRoute
        children={<ReportTotalTrans />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REPORT_EWALLET_COMMISSION_BYDATE,
    element: (
      <PrivateRoute
        children={<ReportEwalletCommissionByDate />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REPORT_CHANNELS,
    element: (
      <PrivateRoute
        children={<ReportChannel />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REPORT_EWALLET_COMMISSION,
    element: (
      <PrivateRoute
        children={<ReportPaymentEwalletCommission />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REPORT_EWALLET_COMMISSION_OBJECT,
    element: (
      <PrivateRoute
        children={<ReportEwalletCommissionByObject />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REPORT_PERCENTAGES,
    element: (
      <PrivateRoute
        children={<ReportPercentage />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: `${UAA_CHILDREN_PATH.REPORT_CHANNELS_DETAIL}/:id/:name/:status`,
    element: (
      <PrivateRoute
        children={<ReportChannelDetail />}
        roles={roleTransactionHistory}
        pathRouter={ `${UAA_CHILDREN_PATH.REPORT_CHANNELS_DETAIL}`}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REPORT_COMMISSION_LIST,
    element: (
      <PrivateRoute
        children={<ReportCommissionList />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.COMMISSION_STAFF_REPORT,
    element: (
      <PrivateRoute
        children={<CommissionSatffReport />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.REPORT_TRANSACTION_DETAIL_BYDATE,
    element: <PrivateRoute children={<ReportTransDetailByDate />} />,
  },
  {
    path: `${UAA_CHILDREN_PATH.REPORT_COMMISSION_DETAIL}/:id`,
    element: (
      <PrivateRoute
        children={<ReportCommissionDetail isDetail />}
        roles={roleTransactionHistory}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.PAYMENT_BATCH_REQUEST,
    element: (
      <PrivateRoute children={<BatchRequest />} roles={rolePaymentReview} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.PAYMENT_BATCH_REQUEST_ADD,
    element: (
      <PrivateRoute children={<BatchRequestAdd />} roles={rolePaymentReview} />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.PAYMENT_BATCH_APPROVE,
    element: (
      <PrivateRoute
        children={<BatchRequestApprove />}
        roles={rolePaymentReview}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.PAYMENT_BATCH_REQUEST_DETAIL,
    element: (
      <PrivateRoute
        children={<BatchRequestDetail />}
        roles={rolePaymentReview}
      />
    ),
  },
  {
    path: UAA_CHILDREN_PATH.PAYMENT_BATCH_APPROVE_DETAIL,
    element: (
      <PrivateRoute
        children={<BatchRequestApproveDetail isDetail />}
        roles={rolePaymentReview}
      />
    ),
  },
];

export const listRoutesChannel = {
  bizzApp: "CHANNEL",
  listRoute: routeRootChannel,
};

export default PrivateRoute;
